import { Box } from '@mui/material';
import TeamEndScore from './teamEndScore';
import TeamFinalScore from './teamFinalScore';
import GameControl from '../gameControls/gameControl';
import ScoreControl from '../gameControls/scoreControl';
import PlayoffScoreControl from '../gameControls/playoffScoreControl';
import { GameStatus } from '../../../constants/gameConstants';
import GameControlSecondary from '../gameControls/gameControlSecondary';
import { useAuth } from '../../../contexts/authContext';

// Two equal columns keep the score pads inside the card on a phone. The pads
// themselves cap their width, so wide screens look the same as before.
const ScoreControlsRow = ({ children }) => (
  <Box
    display="grid"
    gridTemplateColumns={'minmax(0, 1fr) minmax(0, 1fr)'}
    justifyItems={'center'}
    alignItems={'center'}
    columnGap={1}
    width="100%">
    {children}
  </Box>
);

const ScoringDisplay = ({ game, isPublic, portal }) => {
  const { authenticated } = useAuth();

  return game && game.teams?.teamA && game.teams?.teamB ? (
    <>
      <Box
        display="grid"
        gridTemplateColumns={{
          xs: 'minmax(0, 1fr) minmax(0, 1fr)',
          sm: 'minmax(0, 1fr) auto minmax(0, 1fr)'
        }}
        justifyItems={'center'}
        alignItems={'center'}
        columnGap={1}
        rowGap={1}
        width="100%">
        <Box display="flex" justifyContent="center" width="100%" minWidth={0}>
          {game.status === GameStatus.COMPLETE ? (
            <TeamFinalScore team={game.teams.teamA} game={game} />
          ) : (
            <TeamEndScore team={game.teams.teamA} game={game} />
          )}
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          width="100%"
          sx={{
            gridColumn: { xs: '1 / -1', sm: 'auto' },
            gridRow: { xs: 2, sm: 'auto' }
          }}>
          <GameControl game={game} isPublic={isPublic} portal={portal} />
        </Box>
        <Box display="flex" justifyContent="center" width="100%" minWidth={0}>
          {game.status === GameStatus.COMPLETE ? (
            <TeamFinalScore team={game.teams.teamB} game={game} />
          ) : (
            <TeamEndScore team={game.teams.teamB} game={game} />
          )}
        </Box>
      </Box>

      {portal && (
        <ScoreControlsRow>
          {game.status === GameStatus.PLAYOFF && game.playoff ? (
            <PlayoffScoreControl
              game={game}
              team={game.teams.teamA}
              onScore={portal.onPlayoffScore}
              submitting={portal.busy}
            />
          ) : (
            <ScoreControl
              team={game.teams.teamA}
              game={game}
              onScore={portal.onScore}
              submitting={portal.busy}
            />
          )}

          {game.status === GameStatus.PLAYOFF && game.playoff ? (
            <PlayoffScoreControl
              game={game}
              team={game.teams.teamB}
              onScore={portal.onPlayoffScore}
              submitting={portal.busy}
            />
          ) : (
            <ScoreControl
              team={game.teams.teamB}
              game={game}
              onScore={portal.onScore}
              submitting={portal.busy}
            />
          )}
        </ScoreControlsRow>
      )}

      {!portal && authenticated && (
        <ScoreControlsRow>
          {game.status === GameStatus.PLAYOFF && game.playoff ? (
            <PlayoffScoreControl game={game} team={game.teams.teamA} />
          ) : (
            <ScoreControl team={game.teams.teamA} game={game} />
          )}

          {game.status === GameStatus.PLAYOFF && game.playoff ? (
            <PlayoffScoreControl game={game} team={game.teams.teamB} />
          ) : (
            <ScoreControl team={game.teams.teamB} game={game} />
          )}
        </ScoreControlsRow>
      )}

      {!portal && !authenticated && isPublic && (
        <ScoreControlsRow>
          {game.status === GameStatus.PLAYOFF && game.playoff ? (
            <PlayoffScoreControl game={game} team={game.teams.teamA} isPublic={isPublic} />
          ) : (
            <ScoreControl team={game.teams.teamA} game={game} isPublic={isPublic} />
          )}

          {game.status === GameStatus.PLAYOFF && game.playoff ? (
            <PlayoffScoreControl game={game} team={game.teams.teamB} isPublic={isPublic} />
          ) : (
            <ScoreControl team={game.teams.teamB} game={game} isPublic={isPublic} />
          )}
        </ScoreControlsRow>
      )}

      {portal ? (
        <GameControlSecondary game={game} portal={portal} />
      ) : authenticated ? (
        <GameControlSecondary game={game} />
      ) : (
        isPublic && <GameControlSecondary game={game} isPublic={isPublic} />
      )}
    </>
  ) : null;
};

export default ScoringDisplay;
